import Parse from '@/parse'
const Bank = Parse.Object.extend('Bank')
const messages =  {
  update: '銀行情報を更新しました。'
}

export default {
  initForm ({ state, commit }) {
    commit('setName', state.bank.get('name'))
    commit('setBranchName', state.bank.get('branchName'))
    commit('setAccountType', state.bank.get('accountType'))
    commit('setAccountNumber', state.bank.get('accountNumber'))
  },

  async getBank({ commit }, userId) {
    let query = new Parse.Query(Bank)
    query.equalTo('user', userId)
    let bank = await query.first()
    commit('setBank', bank)
  },

  async saveBank ({ state, dispatch }) {
    let bank = state.bank
    bank.set('name', state.name)
    bank.set('branchName', state.branchName)
    bank.set('accountType', state.accountType)
    bank.set('accountNumber', state.accountNumber)

    try {
      await bank.save()
      return messages.update
    } catch (error) {
      dispatch(
        'snackBar/addMessage',
        error,
        { root: true }
      )
    }
  }
}
